import { saveAs } from 'file-saver';
import { pdf, StyleSheet } from '@react-pdf/renderer';
import CharacterPDF from "./CharacterPDF"

const styles = StyleSheet.create({
    page: { backgroundColor: 'white' },
    section: { color: 'black', textAlign: 'center', margin: 30 },
    header: { fontSize: 30 },
    h3: {fontSize: 20},
    paragraph: { fontSize: 12 }
});

// TODO: player name (not character)
// TODO: pushes (can probably leave blank though)
// TODO: GRFs/stress penalties

// PDF export

function FindGeneralAbilityData(data, ability) {
    for (let rowID in data.generalAbilities) {
        let row = data.generalAbilities[rowID];
        if (row.id === parseInt(ability)) {
            return row;
        }
    }
    return null;
}

function FindInvestigativeAbilityData(data, ability) {
    for (let rowID in data.investigativeAbilities) {
        let row = data.investigativeAbilities[rowID];
        if (row.id === parseInt(ability)) {
            return row;
        }
    }
    return null;
}

function FindPowerData(data, power) {
    for (let rowID in data.mutantPowers) {
        let row = data.mutantPowers[rowID];
        if (row.id === parseInt(power)) {
            return row;
        }
    }
    return null;
}

function FormattedGeneralAbilities(data, generalAbilities) {
    var formattedAbilities = [];
    for (let ability in generalAbilities) {
        let abilityData = FindGeneralAbilityData(data, ability);
        let formattedAbility = {
            id: ability,
            name: abilityData.name,
            description: abilityData.description,
            maxPoints: generalAbilities[ability]
        };
        formattedAbilities.push(formattedAbility);
    }
    const allAbilityData = {
        id: 1,
        items: formattedAbilities
    };
    return allAbilityData;
}

function FormattedInvestigativeAbilities(data, investigativeAbilities) {
    var formattedAbilities = [];
    for (let ability in investigativeAbilities) {
        let abilityData = FindInvestigativeAbilityData(data, ability);
        let formattedAbility = {
            id: ability,
            name: abilityData.name,
            description: abilityData.description
        };
        formattedAbilities.push(formattedAbility);
    }
    const allAbilityData = {
        id: 1,
        items: formattedAbilities
    };
    return allAbilityData;
}

function FormattedGeneralPowers(data, powers) {
    var formattedPowers = [];
    for (let p in powers) {
        let powerData = FindPowerData(data, p);
        if (powerData.isInvestigative || powerData.isGRF || powers[p] <= 0) {
            continue;
        }
        let formattedPower = {
            id: p,
            name: powerData.name,
            description: powerData.description,
            maxPoints: powers[p]
        };
        formattedPowers.push(formattedPower);
    }
    const allPowerData = {
        id: 1,
        items: formattedPowers
    };
    return allPowerData;
}

function FormattedInvestigativePowers(data, powers) {
    var formattedPowers = [];
    for (let p in powers) {
        let powerData = FindPowerData(data, p);
        if (!powerData.isInvestigative || powers[p] <= 0) {
            continue;
        }
        let formattedPower = {
            id: p,
            name: powerData.name,
            description: powerData.description
        };
        formattedPowers.push(formattedPower);
    }
    const allPowerData = {
        id: 1,
        items: formattedPowers
    };
    return allPowerData;
}

// generate PDF

const generatePdfDocument = async (data, characterData, fileName, generalPowers) => {
    const generalAbilityData = FormattedGeneralAbilities(data, characterData.generalAbilities);
    const investigativeAbilityData = FormattedInvestigativeAbilities(data, characterData.investigativeAbilities);
    const generalPowerData = FormattedGeneralPowers(data, characterData.powers);
    const investigativePowerData = FormattedInvestigativePowers(data, characterData.powers);
    const blob = await pdf((
        <CharacterPDF
            title={fileName}
            styles={styles}
            characterData={characterData}
            generalAbilities={generalAbilityData}
            investigativeAbilities={investigativeAbilityData}
            generalPowers={generalPowerData}
            investigativePowers={investigativePowerData}
        />
    )).toBlob();
    saveAs(blob, fileName);
};

export default generatePdfDocument;